export default __webpack_public_path__ + "static/media/postgres_monitor.a8c04da8.md";